import { AppHelper } from "../../appHelper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { General } from "../../../siteManagement/general";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Config } from "../../core/config/config";
import { Helper } from "../../core/util/helper";
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { EventInfo } from "../level/level";
import { DialogHelper } from "../../core/util/dialogHelper";
import { SheetEventType, Sheet } from "../../../siteManagement/sheet";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { DateTimePicker } from "../../core/components/dateTimePicker";
import FieldComment from "../fieldComment";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react"
export default class AgreementApp extends React.Component<AgreementAppProps, AgreementAppState> {
    common = new AppHelper();
    private _factory = ComponentHelper.createFactory();
    private _sheet: Sheet; 
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled: boolean;
    isDeleted: boolean;
    translations: StringKeyDictionary<string> = null;
    agreementLevelGridOptions: kendo.ui.GridOptions = null;
    actionRights: ActionRight[];

    constructor(props) {
        super(props);
        this.common.init(this);
        this.props.context.translations = this.translations;
        this.props.context.agreementLevelGridOptions = this.agreementLevelGridOptions;
        this._refreshDeleteEnabled();
        this.state = { dialogOpen: false, dialogDate: null };
        this._sheet = General.Sheet.Manager.getTopMostSheet();
        this.actionRights = this.props.actionRights;
    }
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkDates()) {
                        switch (this.state.dialogType) {
                            case AgreementDialogType.Activating:
                                this._setActive(true, this.state.dialogDate);
                                break;
                            case AgreementDialogType.Closing:
                                this._changeEnd(this.state.dialogDate);
                                break;
                        }
                    } else {
                        switch (this.state.dialogType) {
                            case AgreementDialogType.Activating:
                                DialogHelper.alert(this.translations["WebSMS.SLA.CouldNotActivated"]);
                                break;
                            case AgreementDialogType.Closing:
                                DialogHelper.alert(this.translations["WebSMS.SLA.CouldNotSetInPast"]);
                                break;
                        }
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({
                dialogOpen: false, 
                dialogType: null})
        },
        width: 500
    };
    
    private _checkDates = () => {
        // Die Zeitzone des Vertrages muss rangezogen werden... new Date() liefert aber Benutzer-Zeitzone...
        return (Helper.hasValue(this.state.dialogDate)); /*&& (new Date() < Helper.dates.toDate(this.state.dialogDate)))*/
    }

    private _refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    private _changeEnd = (closeOn: Date) => {
        HTTPService.post<JsonResultClass<AgreementEntity>>('SlaAgreement/Close', { id: this.props.entity.Id, closeOn })
            .then(result => {
                if (result.Code === 0) {
                    HTTPService.get<JsonResultClass<ActionRight[]>>("SlaAgreement/GetRights/?id=" + encodeURI(this.props.entity.Id))
                        .then(rights_result => {
                            //this.props.entity.Active = active;
                            this.actionRights = rights_result.Data;
                            this.props.entity.EndOnLocal = result.Data.EndOnLocal;
                            this.setState({});
                        });
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
}

    private _setActive = (active: boolean, activateOn: Date) =>{
        HTTPService.post<JsonResultClass<AgreementEntity>>("SlaAgreement/SetActive", {id: this.props.entity.Id, active, activateOn})
        .then(result => {
            if (result.Code === 0) {
                HTTPService.get<JsonResultClass<ActionRight[]>>("SlaAgreement/GetRights/?id=" + encodeURI(this.props.entity.Id))
                    .then(rights_result => {
                        //this.props.entity.Active = active;
                        this.actionRights = rights_result.Data;
                        Helper.updateEntity(this.props.entity, result.Data);
                        this._refreshDeleteEnabled();

                        if(active)
                            NotificationHelper.showSuccessMessage(this.translations["WebSMS.SLA.AgreementAktivateSuccess"]);
                        else
                            NotificationHelper.showSuccessMessage(this.translations["WebSMS.SLA.AgreementDeaktivateSuccess"]);
                                    
                        this.setState({});
                    });
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }

            this.common.handlePostSave(result.Code === 0);
        }, () => {

        });
    }

    private _internalAfterSave(entity: AgreementEntity){
        if (this.props.entity.IsNew) {
            this.props.entity.IsNew = false;
            General.Functions.HistoryState.replaceState("SlaAgreement/Edit?id=" + encodeURIComponent(this.props.entity.Id));
        }

        Helper.updateEntity(this.props.entity, entity);
        for(let i = 0; i < this.props.entity.Levels.length; ++i) {
            Helper.updateEntity(this.props.entity.Levels[i], entity.Levels[i])
            Helper.updateEntity(this.props.entity.Levels[i].EndEvent, entity.Levels[i].EndEvent);
        }

        this.props.entity.IsNew = false;
        //this.props.entity.Id = entity.Id;
        //this.props.entity.RecordRight.CanWrite = entity.RecordRight.CanWrite;
        //this.props.entity.Active = entity.Active;
        //Helper.setArrayValues(this.props.entity.Levels, entity.Levels);
        this._refreshDeleteEnabled();
        this.setState({});
    }

    private _createDialog = () => {

        //this._dialogProps.title = this.translations[""];
        switch (this.state.dialogType) {
            case AgreementDialogType.Activating:
                this._dialogProps.title = this.translations["WebSMS.SLA.AktivatingAgreement"];
                break;
            case AgreementDialogType.Closing:
                this._dialogProps.title = this.translations["WebSMS.SLA.ChangeEndDate"];
                break;
        }

        return (
            <Dialog {...this._dialogProps} open={true}>
                {this._createDateTime()}
            </Dialog>
        );
    }

    private _createDateTime = () => {
        let dtprops = this._factory.getDefaultDateTimePickerProps();
        dtprops.value = this.state.dialogDate;
        dtprops.onChange = (field: { model: string }, value: Date, dataItem?: any) => {
            this.setState({dialogDate: value});
        }
        

        let labelText = "";
        let description = "";
        switch (this.state.dialogType) {
            case AgreementDialogType.Activating:
                labelText = this.translations["WebSMS.SLA.ActivateOn"];
                description = this.translations["WebSMS.SLA.AgreementAktivatedOnDate"];
                break;
            case AgreementDialogType.Closing:
                labelText = this.translations["WebSMS.SLA.EndOn"];
                description = this.translations["WebSMS.SLA.AgreementEndedOnDateDesc"];
                break;
        }

        dtprops.timeZone = this.props.entity.TimeZone;

        return(
            <FieldInstance label={labelText + " *"} noHover={true}>
                <DateTimePicker {...dtprops}/>
                <FieldComment text={description}/>
            </FieldInstance>
            );

    }

    canExecute = (action: string) => {
        let index = Helper.findIndex(this.actionRights, "Action", action);
        if (index != -1) {
            return this.actionRights[index].Right;
        }
        return true;
    }

    save = () => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass<AgreementEntity>>("SlaAgreement/Save", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        this._internalAfterSave(result.Data);

                        NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    this.common.handlePostSave(result.Code === 0);
                }, () => {
                });
        }
    }

    setActive = (active: boolean) => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass<AgreementEntity>>("SlaAgreement/Save", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        this._internalAfterSave(result.Data);
                        if (active) {
                            this.setState({
                                dialogOpen: true, 
                                dialogDate: this.props.entity.StartOnLocal,
                                dialogType: AgreementDialogType.Activating
                            });
                        } else {
                            this._setActive(active, null);
                        }
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    this.common.handlePostSave(result.Code === 0);
                }, () => {

                });
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.PartnerAddressNumber":
                this._sheet.trigger(SheetEventType.Custom, { command: "SLAAgreementAdrNrChanged", adrNr: value });
                break;
            case "entity.TimeZone":
                break;
        }


        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        if (field.model === "entity.ServiceHoursTitle") {
            //this.handleFieldChange(field, dataItem ? dataItem.Title : null, dataItem);
        }
    }

    remove = () => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>('SlaAgreement/Delete?id=' + this.props.entity.Id)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/SlaAgreement";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    changeEnd = () => {
        this.setState({
            dialogOpen: true, 
            dialogDate: this.props.entity.EndOnLocal,
            dialogType: AgreementDialogType.Closing
        });
    }

    private _openAgreement = (id) => {
        HTTPService.get<JsonResultClass<AgreementEntity>>("SlaAgreement/Init?id=" + encodeURIComponent(id))
            .then(result => {
                if (result.Code === 0) {
                    HTTPService.get<JsonResultClass<ActionRight[]>>("SlaAgreement/GetRights/?id=" + encodeURI(result.Data.Id))
                        .then(rights_result => {
                            General.Functions.HistoryState.replaceState("SlaAgreement/Edit?id=" + encodeURIComponent(id));
                            this.actionRights = rights_result.Data;
                            Helper.updateEntity(this.props.entity, result.Data);
                            
                            $.extend(this.props.entity.RecordRight, result.Data.RecordRight);
                            
                            if (!Helper.hasValue(this.common.unloadHelper)) {
                                this.common.createUnloadHelper();
                            }
                            this.props.context.keyVal1 = this.props.entity.Id;
                            this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "updateDocuments" });
                            this.setState({});
                        });
                }
            });
    }

    openAgreement = (id) => {
        if (this.props.entity.RecordRight.CanWrite && this.common.entityChanged) {
            if (this.common.validate()) {
                HTTPService.post<JsonResultClass<AgreementEntity>>("SlaAgreement/Save", this.props.entity)
                    .then(result => {
                        if (result.Code === 0) {
                            this._internalAfterSave(result.Data);

                            NotificationHelper.showSuccessMessage(Config.translations.savingSuccessfulMessage);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }

                        this.common.handlePostSave(result.Code === 0);

                        if (result.Code === 0) {
                            this._openAgreement(id);
                        }
                    }, () => {

                    });
            }
        }
        else {
            this._openAgreement(id);
        }
    }

    createFollowOn = () => {
        DialogHelper.confirm(this.translations["WebSMS.SLA.CreatFollowUp"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass<AgreementEntity>>('SlaAgreement/CreateFollowOn', { id: this.props.entity.Id })
                    .then(result => {
                        if (result.Code === 0) {
                            HTTPService.get<JsonResultClass<ActionRight[]>>("SlaAgreement/GetRights/?id=" + encodeURI(result.Data.Id))
                                .then(rights_result => {
                                        General.Functions.HistoryState.replaceState("SlaAgreement/Edit?id=" + encodeURIComponent(result.Data.Id));
                                        this.actionRights = rights_result.Data;
                                        Helper.updateEntity(this.props.entity, result.Data);
                            
                                        $.extend(this.props.entity.RecordRight, result.Data.RecordRight);
                            
                                        if (!Helper.hasValue(this.common.unloadHelper)) {
                                            this.common.createUnloadHelper();
                                        }
                                        this.props.context.keyVal1 = this.props.entity.Id;
                                        this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "updateDocuments" });
                                        this.setState({});
                                    });
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    render() {
        const dialog = this.state.dialogOpen ? this._createDialog() : null;
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return (
            <>
                <CommonApp {...props} />
                {dialog}
            </>
            );
    }
}

export interface AgreementEntity extends Entity {
    Id: string;
    Active?: boolean;
    EndOnLocal: Date;
    StartOnLocal?: Date;
    Levels: AgreementLevelEntity[];
    TicketTypes: AgreementTicketTypeEntity[];
    Machines: AgreementMachineEntity[];
    PartnerAddressNumber: string;
    TimeZone: string;
}

export interface AgreementTicketTypeEntity extends Entity {
    TicketTypeId: string;
    TicketType: string;
}

export interface AgreementMachineEntity extends Entity  {
    MaschNr: string;
    MaschBezeichnung: string;
    MaschNr2: string;
    MaschTyp: string;

}

export interface AgreementLevelEntity extends Entity {
    LevelId: string;
    LevelSourceId: string;
    Title: string;
    StartEvent: EventInfo;
    EndEvent: EventInfo;
    ServiceHoursId: string;
    ServiceHoursTitle: string;
    ReactionTypeStr: string;
    ReactionType: ReactionType;
    AssignmentRelated: boolean;
    ReactionTimeMinutes: number;
    Calendar?: {
        Id: number;
        Name: string;
    }
}

export enum ReactionType {
    Reaction24_7 = 0,
    ReactionCustom = 1
}

export interface ActionRight {
    Action: string;
    Right: boolean;
    Message: string;
}

export interface AgreementAppProps extends AppBaseProps {
    entity: AgreementEntity;
    context: AgreementAppContext;
    actionRights: ActionRight[];
}

export interface AgreementAppContext extends Context{
    translations: StringKeyDictionary<string>;
    agreementLevelGridOptions?: kendo.ui.GridOptions;
}


interface AgreementAppState {
    dialogOpen: boolean;
    dialogDate: Date;
    dialogType?: AgreementDialogType;
}

enum AgreementDialogType {
    Closing,
    Activating
}